module.exports = __webpack_public_path__ + "static/media/Checkbox.5e1ba1be.svg";